import axios from "axios";
import { Dispatch } from "redux";
import { NavigateFunction } from "react-router-dom";
import { baseURL } from "../globals/constants";
import { showErrorToast } from "../utils/Toast";
import { setBreefInviteTrackingData, setBreefInviteUserDetailsData } from "../redux/slices/BreefInviteSlice";
import i18next from "i18next";

export const getBreefInviteTracking = async (
  dispatch: Dispatch,
  isMobile: boolean,
  navigate: NavigateFunction,
  tenantEmail?: string,
  tenantPhone?: string,
  pageLimit?: number,
  pageNo?: number
) => {
  const token = localStorage.getItem("access_token");
  try {
    const limit = pageLimit || 10;
    const page = pageNo || 1;
    const emailParam = tenantEmail ? `&tenantEmail=${encodeURIComponent(tenantEmail)}` : "";
    const phoneParam = tenantPhone ? `&tenantPhone=${encodeURIComponent(tenantPhone)}` : "";
    const response = await axios.get(
      `${baseURL}/v1/breef-invites?limit=${limit}&page=${page}${emailParam}${phoneParam}`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch(setBreefInviteTrackingData(response.data));
    return response.data;
  } catch (error: any) {
    console.log("error ", error);
    if (error?.response?.status === 401) {
      showErrorToast(i18next.t("messages.sessionExpired"), isMobile);
      localStorage.removeItem("access_token");
      navigate("/");
    } else {
      const message = error?.response?.data?.message || "An error occurred while fetching breef tracking data";
      showErrorToast(message, isMobile);
    }
  }
};

export const getBreefInviteUserDetails = async (
  dispatch: Dispatch,
  isMobile: boolean,
  navigate: NavigateFunction,
  breefId: string,
  pageLimit?: number,
  pageNo?: number
) => {
  const token = localStorage.getItem("access_token");
  try {
    const limit = pageLimit || 50;
    const page = pageNo || 1;
    const response = await axios.get(`${baseURL}/v1/breef-invites/${breefId}/users?limit=${limit}&page=${page}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch(setBreefInviteUserDetailsData(response.data));
    return response.data;
  } catch (error: any) {
    console.log("error ", error);
    if (error?.response?.status === 401) {
      showErrorToast(i18next.t("messages.sessionExpired"), isMobile);
      localStorage.removeItem("access_token");
      navigate("/");
    } else {
      const message = error?.response?.data?.message || "An error occurred while fetching invite details";
      showErrorToast(message, isMobile);
    }
  }
};

export const resendBreefInvite = async (inviteId: string, isMobile: boolean, navigate: NavigateFunction) => {
  const token = localStorage.getItem("access_token");
  try {
    const response = await axios.post(
      `${baseURL}/v1/breef-invites/${inviteId}/resend`,
      {},
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.log("error ", error);
    if (error?.response?.status === 401) {
      showErrorToast(i18next.t("messages.sessionExpired"), isMobile);
      localStorage.removeItem("access_token");
      navigate("/");
    } else {
      const message = error?.response?.data?.message || "An error occurred while resending the invite";
      showErrorToast(message, isMobile);
    }
    throw error;
  }
};
